import React from 'react'

const OrderExchangeDetails = () => {
  return (
    <div>OrderExchangeDetails</div>
  )
}

export default OrderExchangeDetails